import React, { useState } from 'react';
import { Grid, InputAdornment, TextField } from '@material-ui/core';
import { KeyboardDatePicker } from '@material-ui/pickers';
import { DeepMap, FieldError } from 'react-hook-form';
import { useDatePickerStyles } from '../styled';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
interface DatePickerProps {
  value: Date;
  minDate: Date;
  onChange: (...event: any[]) => void;
  name: string;
  inputProps?: any;
  errors?: DeepMap<Record<string, any>, FieldError>;
  placeholder?: string;
  helperText?: string;
  error: any;
  sendLog?: () => void;
}

const DatePicker = (props: DatePickerProps) => {
  const classes = useDatePickerStyles();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handlePopoverOpen = (
    event: React.MouseEvent<HTMLElement, MouseEvent>
  ) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const formatDate = (value: Date | null): string => {
    if (!value) return '';
    let year = value.getFullYear(),
      month = '' + (value.getMonth() + 1),
      day = '' + value.getDate(),
      hour = '' + value.getHours(),
      minutes = '' + value.getMinutes();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    if (hour.length < 2) hour = '0' + hour;
    if (minutes.length < 2) minutes = '0' + minutes;

    const result = '~YYYY.MM.DD'
      .replace('YYYY', String(year))
      .replace('MM', String(month))
      .replace('DD', String(day))
      .replace('HH', String(hour))
      .replace('mm', String(minutes));

    return result;
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <Grid container justifyContent="space-around">
      <KeyboardDatePicker
        disableToolbar
        variant="inline"
        format="~yyyy/MM/dd"
        style={{ display: 'none' }}
        id="date-picker-inline"
        value={props.minDate}
        name={props.name}
        minDate={props.minDate}
        onChange={(e) => {
          if (props.sendLog) {
            props.sendLog();
          }
          props.onChange(e);
        }}
        renderDay={(day, selectedDate, isInCurrentMonth, dayComponent) => {
          if (day?.getDay() === 0)
            return <p className={classes.sun}>{dayComponent}</p>;

          if (day?.getDay() === 6)
            return <p className={classes.sat}>{dayComponent}</p>;
          return <p className={classes.day}>{dayComponent}</p>;
        }}
        autoOk={true}
        PopoverProps={{
          id: id,
          open: open,
          className: classes.wrapper,
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left'
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'left'
          },
          disableRestoreFocus: true,
          anchorEl: anchorEl
        }}
        KeyboardButtonProps={{
          onClick: () => setAnchorEl(null)
        }}
        onClose={handlePopoverClose}
      />
      <TextField
        inputProps={{ ...props.inputProps }}
        variant="outlined"
        placeholder={props.placeholder}
        error={props.error ? true : false}
        helperText={props.error && props.helperText}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <CalendarTodayIcon
                style={{ color: '#939FA5', cursor: 'pointer' }}
              />
            </InputAdornment>
          )
        }}
        fullWidth={true}
        size={'small'}
        value={formatDate(props.value)}
        onClick={handlePopoverOpen}
      />
    </Grid>
  );
};

export default DatePicker;
